import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { getHubFeatureFlagActions, getOfferFeatureFlagActions } from '../actions/feature-flag.action';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { Store } from '@ngrx/store';
import { selectHubFeatureFlags, selectOfferFeatureFlags } from '../selectors/feature-flag.selector';
import { ApiEffects } from '../../utils/effects.util';

@Injectable()
export class FeatureFlagsEffects extends ApiEffects {
  constructor(
    readonly actions$: Actions,
    private readonly featureFlagService: FeatureFlagService,
    private readonly store: Store
  ) {
    super(actions$);
  }

  getHubFeatureFlags$ = this.createCachedApiEffect({
    actions: getHubFeatureFlagActions,
    effectFn: (request) => this.featureFlagService.getFeatureFlags(request),
    cachedObservable: this.store.select(selectHubFeatureFlags),
  });

  getOfferFeatureFlags$ = this.createCachedApiEffect({
    actions: getOfferFeatureFlagActions,
    effectFn: (request) => this.featureFlagService.getFeatureFlags(request),
    cachedObservable: this.store.select(selectOfferFeatureFlags),
  });
}
